import { Button, Title } from "@mantine/core";
import { ContextModalProps } from "@mantine/modals";

import { useDeleteCompanyMutation } from "@/store";

type DeleteOrderProps = {
  id: number;
};
export function DeleteCompany({ context, id, innerProps }: ContextModalProps<DeleteOrderProps>) {
  const [deleteCompany, { isLoading }] = useDeleteCompanyMutation();

  const handleDeny = () => {
    context.closeModal(id);
  };

  const handleConfirm = async () => {
    await deleteCompany({ id: innerProps.id });
    context.closeModal(id);
  };

  return (
    <div>
      <Title c="primary" order={2} ta="center" mb="md">
        Confirme a exclusão
      </Title>

      <div className="flex flex-col gap-4 text-center">
        <p>Tem certeza de que deseja excluir esta empresa?</p>

        <div className="grid grid-cols-1 gap-1 md:grid-cols-2 md:gap-2">
          <Button onClick={handleDeny} color="red" disabled={isLoading}>
            Cancelar
          </Button>

          <Button onClick={handleConfirm} color="green" loading={isLoading}>
            Confirmar
          </Button>
        </div>
      </div>
    </div>
  );
}
